import React, { Component } from "react";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import { Row, Col } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';

export class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.onMarkerClick = this.onMarkerClick.bind(this);
        this.state = {
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
            pumps: [
                { lat: 35.920834, lng: 74.308334 },
                { latitude: 29.143644, longitude: 71.257240 },
                { latitude: 31.976515, longitude: 74.222015 },
                { latitude: 30.767956, longitude: 72.437813 },
                { latitude: 28.281891, longitude: 68.438171 },
                { latitude: 30.677717, longitude: 73.106812 },
                { latitude: 32.337006, longitude: 74.903336 },
                { latitude: 30.286415, longitude: 71.932030 },
                { latitude: 31.345394, longitude: 73.429810 },
                { latitude: 33.148392, longitude: 73.751770 }
            ],
            allSelectedPlaces: []
        };
    }
    onMarkerClick(props, marker, e) {
        console.log(props)
        this.setState((prevState) => ({
            allSelectedPlaces: [...prevState.allSelectedPlaces, props.name]
        }));
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    }

    displayMarkers = () => {
        return this.state.pumps.map((store, index) => {
            return <Marker key={index} id={index} name={'Map Location: ' + index} title={index} position={{
                lat: store.latitude,
                lng: store.longitude
            }}
                //onClick={(evt) => console.log(evt)} 
                onClick={this.onMarkerClick}


            />
        })
    }

    render() {
        if (!this.props.google) {
            return <div>Loading...</div>;
        }

        return (


            <Row>
                <Col xs={2}>
                    <h5>Selected Pointers</h5>

                    <ul class="list-group">
                        {/* <li class="list-group-item">David Copperfield</li>
                        <li class="list-group-item">The Portrait of a Lady</li>
                        <li class="list-group-item">The Trial</li> */}

                        {
                                    this.state.allSelectedPlaces.map((el, index) => {
                                        //console.log(el)
                                        return(
                                            
                                            <li class="list-group-item"><FeatherIcon className="iconspacing-Nav" icon="map-pin" size="15"  />{el}</li>
                                        )
                                    }
                                        // el.lat
                                        // console.log(el)
                                      )



                        }
                    </ul>

                </Col>
                <Col style={{
                    position: "relative",
                    height: "calc(100vh - 20px)"
                }}>
                    <Map style={{}}
                        google={this.props.google}
                        zoom={6}
                        initialCenter={
                            {
                                lat: 30.44166667, lng: 69.35972222
                            }
                        }

                    >
                        {/* <Marker
            onClick={this.onMarkerClick}
            icon={{
              url: "/img/icon.svg",
              anchor: new window.google.maps.Point(32, 32),
              scaledSize: new window.google.maps.Size(64, 64)
            }}
            name={"Current location"}
          /> */}
                        {this.displayMarkers()}
                        <InfoWindow
                            marker={this.state.activeMarker}
                            visible={this.state.showingInfoWindow}
                        >
                            <div>
                                <h1>{this.state.selectedPlace.name}</h1>
                            </div>
                        </InfoWindow>
                    </Map>
                </Col>
            </Row>





            //   <div
            // style={{
            //   position: "relative",
            //   height: "calc(100vh - 20px)"
            // }}
            //   >

            //   </div>
        );
    }
}
export default GoogleApiWrapper({
    apiKey: "AIzaSyAyesbQMyKVVbBgKVi2g6VX7mop2z96jBo",
    v: "3.30"
})(MapContainer);
